/**
 * АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — не редактировать вручную.
 * Источник: apps/platform/src/app/[lang]/** (статичные page.tsx без динамических сегментов).
 * Перегенерация: cd apps/admin && bun run gen:platform-routes
 */

export interface PlatformRoute {
  path: string;
  label: string;
}

export const PLATFORM_ROUTES: PlatformRoute[] = [
  { path: '/bonuses', label: 'Бонусы' },
  { path: '/channel-passes', label: 'Подписки в канал' },
  { path: '/chat', label: 'Чаты' },
  { path: '/chat/search', label: 'Чаты → Поиск' },
  { path: '/club', label: 'Клуб' },
  { path: '/club/meetings', label: 'Клуб → Встречи' },
  { path: '/content', label: 'Лента контента' },
  { path: '/courses', label: 'Каталог курсов' },
  { path: '/dashboard', label: 'Главная (дашборд)' },
  { path: '/games', label: 'Игры' },
  { path: '/games/card-color', label: 'Игры → Цвет карты' },
  { path: '/games/guess-number', label: 'Игры → Угадай число' },
  { path: '/legal', label: 'Документы' },
  { path: '/library', label: 'Библиотека' },
  { path: '/livestreams', label: 'Трансляции' },
  { path: '/my-courses', label: 'Мои курсы' },
  { path: '/planner', label: 'Планировщик' },
  { path: '/posts/create', label: 'Посты → Создание' },
  { path: '/profile', label: 'Профиль' },
  { path: '/profile/edit', label: 'Профиль → Редактирование' },
  { path: '/settings', label: 'Настройки' },
  { path: '/settings/privacy', label: 'Настройки → Приватность' },
  { path: '/settings/security/devices', label: 'Настройки → Безопасность → Устройства' },
  { path: '/settings/security/recovery', label: 'Настройки → Безопасность → Восстановление' },
  { path: '/subscriptions', label: 'Абонементы' },
  { path: '/subscriptions/family', label: 'Абонементы → Семейный абонемент' },
];
